import { Box, type SxProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";

const defaultSx: SxProps<Theme> = {
  maxWidth: 1200,
  mx: "auto",
  px: { xs: 2, sm: 3, lg: 4 },
  py: { xs: 4, lg: 6 },
};

interface PageContainerProps {
  children: ReactNode;
  /** Override or extend the default page width / padding. */
  sx?: SxProps<Theme>;
}

export function PageContainer({ children, sx }: PageContainerProps) {
  return (
    <Box sx={sx ? ([defaultSx, sx] as SxProps<Theme>) : defaultSx}>
      {children}
    </Box>
  );
}
